import { useEffect } from "react";
import { Container } from "react-bootstrap";
import { useLocation } from "react-router-dom";
// import onboardImg from "../../../assets/images/onboard-img.svg";
import logo from '../../../assets/logos/text-logo-white.svg';
import styles from "./OnboardLayout.module.scss";

const OnboardLayout = (props) => {
  const location = useLocation();
  useEffect(() => {
    document.body.style.background = "white";
  }, [location]);
  return (
    <main className={styles.onboard}>
      {/* Starting */}
      <Container>
        <div className={styles.onboard_inner}>
          <div className={styles.onboard_right}>
            <div className={styles.onboard_right_inner}>
              <img src={logo} alt="logo" />
              <h3 className="big">The simplest way to manage</h3>
              <h1 className="big">Your STBL Portfolio</h1>
              {/* <p>
                Enjoy the world’s largest cryptocurrency exchange at your
                fingertips.
              </p> */}
            </div>
          </div>
          <div className={styles.onboard_left}>
            {/* <Outlet /> */}
            {props.children}
          </div>
        </div>
      </Container>
    </main>
  );
};

export default OnboardLayout;
